export default {
  namespaced: true,
  state: {
    prevRoute: null,
  },
  mutations: {
    setPrevRoute(state, route) {
      state.prevRoute = route;
    },
  },
};
